import { getNewbieFinish } from '@/api/index-page'
import { checkAndIncreaseUserPageVisitNum } from '@/api/user'

export enum PAGE_OR_MODULE_VALUE {
  /** 菜单介绍 */
  SIDE_MENU = 'SIDE_MENU',
  /** 供货记录 页面 */
  SUPPLY_RECORDS = 'SUPPLY_RECORDS',
  /** 收货异常记录 页面 */
  REJECT_RECORDS = 'REJECT_RECORDS',
  /** 消息种子呢 */
  NOTICE_CENTER = 'NOTICE_CENTER'
}

/** 访问次数接口的 操作类型 */
export enum OPERATION_TYPE_VALUE {
  /** 增加访问次数 */
  VISIT = 'VISIT',
  /** 查看访问次数 */
  SEE = 'SEE',
  /** 删除访问次数 */
  CLEAR = 'CLEAR'
}

/** 查询 指定页面或模块的访问次数 */
export const getPageVisitCount = async (pageOrModule: PAGE_OR_MODULE_VALUE) => {
  try {
    const resList = await checkAndIncreaseUserPageVisitNum({
      operation: OPERATION_TYPE_VALUE.SEE,
      pageOrModule
    })
    const getItem = (resList || []).find((item) => item.pageOrModule === pageOrModule)
    if (getItem) {
      return getItem.num || 0
    }
    return 0
  } catch (error) {
    console.log('getPageVisitCount fail', error)
    return 0
  }
}

/** 增加 指定页面或模块的访问次数 */
export const addPageVisitCount = async (pageOrModule: PAGE_OR_MODULE_VALUE) => {
  try {
    await checkAndIncreaseUserPageVisitNum({
      operation: OPERATION_TYPE_VALUE.VISIT,
      pageOrModule
    })
  } catch (error) {
    console.log('addPageVisitCount fail', error)
  }
}

/** 清空 指定页面或模块的访问次数 */
export const clearPageVisitCount = async (pageOrModule: PAGE_OR_MODULE_VALUE) => {
  try {
    await checkAndIncreaseUserPageVisitNum({
      operation: OPERATION_TYPE_VALUE.CLEAR,
      pageOrModule
    })
  } catch (error) {
    console.log('clearPageVisitCount fail', error)
  }
}

/** 获取新手指引是否已经完成 */
export const getIsNewbieFinish = async () => {
  try {
    const { beFinishNewbieGuide } = await getNewbieFinish()
    return beFinishNewbieGuide === 1
  } catch (error) {
    console.log('getNewbieFinish fail', error)
    return true
  }
}
